<template>
  <button
    :type="type"
    :class="[
      'inline-flex items-center justify-center gap-0.75 rounded-[1px] border leading-none font-semibold whitespace-nowrap shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] transition focus-visible:ring-2 focus-visible:outline-none enabled:active:translate-y-px disabled:pointer-events-none disabled:opacity-60',
      contentAlignClass,
      sizeClass,
      toneClass,
      block ? 'w-full' : '',
      widthClass,
    ]"
  >
    <slot name="leading" />
    <slot />
    <slot name="trailing" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    block?: boolean;
    contentAlign?: 'between' | 'center';
    size?: 'sm' | 'md';
    tone?: 'accent' | 'chrome' | 'danger' | 'panel' | 'subtle';
    type?: 'button' | 'submit' | 'reset';
    width?: 'auto' | 'toolbar-medium' | 'toolbar-wide';
  }>(),
  {
    block: false,
    contentAlign: 'center',
    size: 'md',
    tone: 'chrome',
    type: 'button',
    width: 'auto',
  },
);

const sizeClass = computed(() =>
  props.size === 'sm' ? 'min-h-5.25 px-1.5 conference-text-control' : 'min-h-6.25 px-2 conference-text-control',
);
const contentAlignClass = computed(() => (props.contentAlign === 'between' ? 'justify-between' : 'justify-center'));
const widthClass = computed(() => {
  switch (props.width) {
    case 'toolbar-medium':
      return 'min-w-18.5';
    case 'toolbar-wide':
      return 'min-w-21.5';
    default:
      return '';
  }
});

const toneClass = computed(() => {
  switch (props.tone) {
    case 'accent':
      return 'border-conference-accent-border bg-conference-accent text-conference-accent-text enabled:hover:border-conference-accent-border enabled:hover:bg-conference-control-highlight focus-visible:ring-conference-accent/35';
    case 'danger':
      return 'border-conference-danger-border bg-conference-danger-fill text-conference-danger-text enabled:hover:bg-conference-danger-fill-strong focus-visible:ring-conference-accent/35';
    case 'panel':
      return 'border-conference-panel-border bg-conference-structure text-white enabled:hover:border-conference-accent-border enabled:hover:text-conference-control-highlight focus-visible:ring-conference-accent/25';
    case 'subtle':
      return 'border-conference-border bg-white text-conference-structure enabled:hover:border-conference-accent-border enabled:hover:bg-conference-accent-soft enabled:hover:text-conference-accent-text focus-visible:ring-conference-accent/20';
    default:
      return 'border-conference-panel-border bg-conference-structure text-white enabled:hover:border-conference-accent-border enabled:hover:text-conference-control-highlight focus-visible:ring-conference-accent/25';
  }
});
</script>
